// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".loaderScreen_9da {\n  position: absolute;\n\n  width: 100%;\n  height: 100%;\n\n  text-align: center;\n  vertical-align: middle\n}\n\n.loaderScreen_9da::before {\n    display: inline-block;\n\n    height: 100%;\n\n    content: '';\n\n    vertical-align: middle;\n  }\n\n.loader_a93 {\n  display: inline-block;\n}\n\n.loaderWithoutSpacing_135 canvas {\n  margin: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"loaderScreen": "loaderScreen_9da",
	"loader": "loader_a93",
	"loaderWithoutSpacing": "loaderWithoutSpacing_135"
};
module.exports = exports;
